import React, {FC} from 'react';

import {useCustomTable} from 'components/@common/widgets/custom-table/custom-table';
import {EmptyTablePlaceholder} from 'components/table';
import {ITableReportProps} from 'components/table-report/table-report-types';
import {useFetchControlRatioCalculationTableQuery} from 'features/calculate-control-ratios/api/api';
import {DEFAULT_PAGE_SIZE} from 'features/calculate-control-ratios/model/constants';
import {usePagination} from 'shared/hooks/use-pagination';
import {getTablePaginationDefaultConfig} from 'shared/utils';

import {CONTROL_RATIOS_CALCULATION_TABLE_COLUMNS} from '../columns/table-columns';

interface IControlRatiosStatisticProps {
    parentDocId: ITableReportProps['docId'];
    childDocId: ITableReportProps['docId'];
}

export const ControlRatiosStatisticTable: FC<IControlRatiosStatisticProps> = ({
    parentDocId,
    childDocId,
}: IControlRatiosStatisticProps) => {
    const {
        current,
        pageSize,
        handleChange,
    } = usePagination({pageDefault: 1, pageSizeDefault: DEFAULT_PAGE_SIZE});

    const {
        data: tableData,
        isFetching: isTableLoading,
    } = useFetchControlRatioCalculationTableQuery({
        parentDocId,
        childDocId,
        paginationCurrent: current,
        paginationPageSize: pageSize,
    });

    const {
        customTableJSX,
    } = useCustomTable({
        rowKey: 'id',
        dataSource: tableData?.dataTable,
        bordered: true,
        columns: CONTROL_RATIOS_CALCULATION_TABLE_COLUMNS,
        pagination: {
            ...getTablePaginationDefaultConfig({defaultPageSize: DEFAULT_PAGE_SIZE}),
            total: tableData?.recordsTotal,
            pageSize,
            onChange: handleChange,
        },
        locale: {
            emptyText: (
                <EmptyTablePlaceholder
                    isTableLoading={isTableLoading}
                    dataLength={tableData ? tableData.dataTable.length : 0}
                />),
        },
    });

    return (
        <>
            {customTableJSX}
        </>
    );
};
